module.exports = __webpack_public_path__ + "img/banner-wallet.a9dce6cd.png";